import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import DocumentView, { DocumentViewProps } from './DocumentView';

interface DocumentViewWrapperProps {
    type?: string;
}

const DocumentViewWrapper = ({ type }: DocumentViewWrapperProps) => {
    const url = window.location.href;
    const [appParams, setAppParams] = useState<DocumentViewProps>({
        publicationNumber: '',
        documentType: '',
        kindCode: '',
        publicationDate: '',
    });
    const urlParams = useParams();

    useEffect(() => {
        const setData = (val: DocumentViewProps) => {
            if (JSON.stringify(appParams) !== JSON.stringify(val)) {
                setAppParams(val);
            }
        };

        const extractVariables = () => {
            const urlObject = new URL(url);
            // Extracting variables
            const publicationNumber = urlObject.searchParams.get('pn') || '';
            const kindCode = urlObject.searchParams.get('ki') || '';

            const documentType = type || '';
            const publicationDate = urlObject.searchParams.get('pd') || '';

            // Create an object to store the variables
            const variablesObject = {
                publicationNumber,
                kindCode,
                documentType,
                publicationDate: publicationDate
                    ? `${publicationDate.replace('-', '').substring(0, 4)}-${publicationDate.substring(
                          4,
                          6,
                      )}-${publicationDate.substring(6, 8)}`
                    : '',
            };

            return variablesObject;
        };

        console.log("urlParams", urlParams)
       
        if (urlParams && Object.keys(urlParams).length) {
            const { publicationNumber, documentType, kindCode, publicationDate } = urlParams;
            const newVariables = {
                publicationNumber: publicationNumber || '',
                documentType: documentType || '',
                kindCode: kindCode || '',
                publicationDate: publicationDate || '',
            };
            setData(newVariables);
        } else {
            const newVariables = extractVariables();
            setData(newVariables);
        }
    }, [appParams, type, url, urlParams]);

    return appParams.documentType && appParams.kindCode ? (
        <DocumentView
            publicationNumber={appParams.publicationNumber}
            documentType={appParams.documentType}
            kindCode={appParams.kindCode}
            publicationDate={appParams.publicationDate}
        />
    ) : null;
};

export default DocumentViewWrapper;
